import { styled, Typography, TypographyProps } from '@mui/material';

type LinkProps = {
  disabled?: boolean;
} & TypographyProps;

export const Link = styled(Typography)<LinkProps>(({ disabled, theme }) => ({
  ...theme.typography['body-2-md'],
  color: disabled ? theme.palette.primary[300] : theme.palette.primary[700],
  textAlign: 'center',
  alignSelf: 'center',
  pointerEvents: disabled ? 'none' : undefined,
  cursor: disabled ? 'default' : 'pointer',
}));
